export const translations = {
	'Are you sure you want to delete dashboard?': {
		en: 'Are you sure you want to delete dashboard?',
		no: 'Vil du slette dashboard?',
	},
	'Are you sure you want to delete {0} dashboards?': {
		en: 'Are you sure you want to delete {0} dashboards?',
		no: 'Vil du slette {0} dashboardene?',
	},
	'Not able to import dashboard. There might be an issue with the file.': {
		en: 'Not able to import dashboard. There might be an issue with the file.',
		no: 'Klarte ikke å importere dashboard. Det kan være noe feil med filen.',
	},
	'Dashboard was successfully imported.': {
		en: 'Dashboard was successfully imported',
		no: 'Dashboard ble importert',
	},
	'Click to copy public/private dashboard link': {
		en: 'Click to copy public/private dashboard link',
		no: 'Klikk for å kopiere offentlig/private dashboard lenken',
	},
	'Set as public': {
		en: 'Set as public',
		no: 'Sett som felles',
	},
	'Set as private': {
		en: 'Set as private',
		no: 'Sett som privat',
	},
	'Duplicate': {
		en: 'Duplicate',
		no: 'Duplikat',
	},
	'Mobile': {
		en:'Mobile',
		no: 'Mobil',
	},
	'Link': {
		en:'Link',
		no: 'Link',
	},
	'Access': {
		en:'Access',
		no: 'Tilgang',
	},
    'Legacy': {
       en: 'Legacy',
       no: 'Eldre',
    },
    'Dashboard': {
	   en: 'Dashboard',
       no: 'Dashboard',
    },
    'Edit path': {
	   en: 'Edit path',
       no: 'Rediger sti',
    },
	'Updated': {
		en:'Updated',
		no: 'oppdatert',
	},
	'Link is copied': {
		en: 'Copied link',
		no: 'Kopierte lenken',
	},
	'Public mode: Viewable by anyone with the link': {
		en:'Public mode: Anyone with the link can view',
		no: 'Offentlig modus: Kan vises av alle som har lenken',
	},
	'Private mode: Requires login to access': {
		en: 'Private mode: Requires login to access',
		no: 'Privat modus: Krever innlogging for tilgang',
	},
};
